import { render, staticRenderFns } from "./Lokacija.vue?vue&type=template&id=4470a3de&scoped=true"
import script from "./Lokacija.vue?vue&type=script&lang=js"
export * from "./Lokacija.vue?vue&type=script&lang=js"
import style0 from "./Lokacija.vue?vue&type=style&index=0&id=4470a3de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4470a3de",
  null
  
)

export default component.exports